import { pipe } from 'fp-ts/lib/function';
import { failure, parse, string, success } from 'io-ts/Decoder';

/**
 * Validate the channel arn
 * like arn:aws:chime:us-east-1:1234567890:app-instance/62780ea2-b92b-4c16-8596-d65733ffce9c/channel/c1b1597b-d438-4fb8-a27a-8921ea6ea6d6
 */
export const ChimeChannelArn = pipe(
	string,
	parse((s) =>
		// test with a regexp
		/^arn:aws:chime:[a-z]{2}-[a-z]{4}-\d:[0-9]{12}:app-instance\/[a-z0-9-]+\/channel\/[a-z0-9-]+$/i.test(
			s
		)
			? success(s)
			: failure(s, 'ChannelArn is not a valid Chime channel arn')
	)
);
